/**
 *
 *  offcanvas-menu.js
 *
 * Date: 2017. 02. 26. 13:53
 * Version: 1.0
 * Author: Kádár Péter <kp@kpdesign.hu>
 * Project: richter-microsite
 */

$(function () {
  var $body = $('body'),
      $btn = $('.js-offcanvas-toggle'),
      $menu = $($btn.data('target'));

  $body.prepend('<div class="overlay"></div>');
  var $overlay = $('.overlay');

  $btn.click(function(e) {
    e.preventDefault();
    toggleOffCanvasMenu();
  });

  $overlay.on('click', function() {
    toggleOffCanvasMenu();
  });

  function isMenuOpened() {
    return $menu.hasClass('is-open');
  }

  function toggleOffCanvasMenu() {
    $btn.toggleClass('is-active');
    $body.toggleClass('show-overlay');

    if (isMenuOpened()) {
      $menu.removeClass('is-open').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        //$('body').addClass('u-overflow-hidden');
      });
    } else {
      $menu.addClass('is-open').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        //$('body').addClass('u-overflow-hidden');
      });
    }
  }
});

/**
 *
 *  survey.js
 *
 * Date: 2017. 02. 27. 22:17
 * Version: 1.0
 * Author: Kádár Péter <kp@kpdesign.hu>
 * Project: richter-microsite
 */
$(function () {
  // survey
  $('.js-integer').keyup(function () {
      this.value = this.value.replace(/[^0-9\.]/g, '');
  });

  $('.js-bmi-input').keyup(function () {
    var weight = $('.js-bmi-weight').val(),
        height = $('.js-bmi-height').val()/100,
        bmi,
        help = '',
        $bmi = $('.js-bmi'),
        $bmiHelp = $('.js-bmi-help');

    if (weight && height) {
      bmi = weight / (height * height);
      var bmi_rounded = Math.round(bmi * 100) / 100;
      if (bmi_rounded >= 15 && bmi_rounded < 20) {
        help = 'Az érték azt mutatja, hogy testsúlyod a normál tartomány alá esik, így a sovány kategóriába tartozol.'
      }
      else if (bmi_rounded >= 20 && bmi_rounded < 25) {
        help = 'Az érték azt mutatja, hogy testsúlyod az ideális tartományba esik, így a normál kategóriába tartozol.'
      }
      else if (bmi_rounded >= 25 && bmi_rounded < 30) {
        help = 'Az érték azt mutatja, hogy testsúlyod a túlsúlyosok tartományba esik, így a túlsúlyos kategóriába tartozol.'
      }
      else if (bmi_rounded >= 30 && bmi_rounded < 35) {
        help = 'Az érték azt mutatja, hogy testsúlyod az erősen túlsúlyosok tartományba esik, így az elhízott kategóriába tartozol.'
      }
      else if (bmi_rounded >= 35 && bmi_rounded < 60) {
        help = 'Az érték azt mutatja, hogy testsúlyod a túlsúlyosok felső tartományba esik, így az erősen elhízott kategóriába tartozol.'
      } else {
        help = '';
      }
      $bmi.html(Math.round(bmi * 100) / 100);
      $bmiHelp.html(help);
    }
  });

  $('.js-custom').keyup(function() {
    var target = $(this).data('target');
    if (target) {
      if ($(this).val() || $(this).val().length > 0) {
        $(target).prop("checked", true);
      } else {
        $(target).prop("checked", false);
      }
    }
  });
});
/**
 *
 *  frontend-v1.3.js
 *
 * Version: 1.3
 * Author: Kádár Péter <kp@kpdesign.hu>
 * Project: richter-microsite
 */

$(function () {
  // init frontpage slider
  $('.js-slider').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: true,
    pauseOnHover: false,
    pauseOnDotsOver: false
  });

  // Tabs
  var hash = window.location.hash;
  var $tabLink = $('a[href="' + hash + '"]');
  var current_page = window.location.pathname.replace(/\/+$/, "").replace(/^\//, '').split('/');
  if ($tabLink) {
    $tabLink.click();
    var page_url = current_page[current_page.length - 1];
    switch (page_url) {
      case 'fogamzasgatlas':
        if (!hash) {
          $tabLink = $('a[href="#tabletta"]');
        }
        break;
      case 'fogamzasgatlas-egyeb-lehetosegek':
        if (!hash) {
          $tabLink = $('a[href="#pesszarium"]');
        }
        break;
      case 'fogantatas':
        if (!hash) {
          $tabLink = $('a[href="#etkezes"]');
        }
        break;
      case 'fogantatas-lelek':
        if (!hash) {
          $tabLink = $('a[href="#stresszmentesseg"]');
        }
        break;
      case 'fogantatas-meddosegi-kezelesek':
        if (!hash) {
          $tabLink = $('a[href="#hormonkezeles"]');
        }
        break;
    }
    var event_action = $tabLink.data('ga-event-action');
    var event_category = $tabLink.data('ga-event-category');
    if (_env == 'dev') {
      console.log("auto send event | category: " + event_category + "; action: " + event_action);
    } else {
      ga('send', 'event', {eventCategory: event_category, eventAction: event_action});
    }

    scrollto($tabLink);
  }

  $('a[data-toggle="tab"]').click(function (e) {
    e.preventDefault();
    $(this).tab('show');
    window.location.hash = this.hash;
  });

  $('a[data-toggle="tablink"]').click(function (e) {
    e.preventDefault();
    $('.icon-tabs a[href="'+this.hash+'"]').tab('show');
    scrollto($('.tab-content'));
  });

  function scrollto(target) {
    if (target) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 250);
    }
    return false;
  }

  // interaktív navigáció a főoldalon
  var $form        = $('#js-frontpage-form');
  var $formButtons = $('#js-frontpage-form-buttons');
  var $formTrigger = $('#js-frontpage-form-trigger');
  var $radioAge    = $("input[name='FrontpageForm[age]']");
  var $radioWhen   = $("input[name='FrontpageForm[when]']");
  var $radioSince  = $("input[name='FrontpageForm[since]']");

  $formTrigger.on('click', function (e) {
    e.preventDefault();
    var target = $(this).attr('href');
    if ($(target).hasClass('is-open')) {
      $(target).removeClass('is-open');
    } else {
      $(target).addClass('is-open');
    }
  });

  $radioAge.on('change', function (e) {
    validateForm();
  });

  $radioWhen.on('change', onChangeWhen);

  $radioSince.on('change', onChangeSince);

  function onChangeWhen() {
    uncheckSinceRadio();
    if ('2' === $(this).val()) {
      checkSinceRadio();
    }
    validateForm();
  }

  function onChangeSince() {
    checkWhenRadioIfSince();
    validateForm();
  }

  function checkWhenRadioIfSince() {
    $('.js-frontpage-form__when').each(function () {
      if ('2' === $(this).val()) {
        $(this).prop('checked', true);
      }
    });
  }

  function uncheckSinceRadio() {
    $('.js-frontpage-form__since').prop('checked', false);
  }

  function checkSinceRadio() {
    $('.js-frontpage-form__since').each(function () {
      if ('0' === $(this).val()) {
        $(this).prop('checked', true);
      }
    });
  }

  function validateForm() {
    var age = $radioAge.filter(':checked').val();
    var when = $radioWhen.filter(':checked').val();
    var since = $radioSince.filter(':checked').val();

    if (undefined === since) {
      if (undefined === age || undefined === when) {
        $formButtons.addClass('is-hidden');
        return false;
      } else {
        $formButtons.removeClass('is-hidden');
        return true;
      }
    } else {
      if (undefined === age || undefined === when) {
        $formButtons.addClass('is-hidden');
        return false;
      } else {
        $formButtons.removeClass('is-hidden');
        return true;
      }
    }
  }

  $form.on('beforeSubmit', function (e) {
    return validateForm();
  });

  // Google Analytics
  var ga_selector = '.js-ga';
  $(ga_selector).click(function () {
    var event_action = $(this).data('ga-event-action'),
      event_category = $(this).data('ga-event-category');
    if (_env == 'dev') {
      console.log([event_action, event_category]);
    } else {
      ga('send', 'event', {eventCategory: event_category, eventAction: event_action});
    }
  });

  // Back to top
  var showBackToScrollAt = 300;
  var $scrollTopBtn      = document.getElementById('jsScrollTop');

  $scrollTopBtn.addEventListener('click', function (e) {
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0
      //behavior: 'smooth'
    });
  });

  if (window.scrollY >= showBackToScrollAt) {
    $scrollTopBtn.classList.add('is-visible');
  }
  window.addEventListener('scroll', function (event) {
    if (window.scrollY >= showBackToScrollAt) {
      $scrollTopBtn.classList.add('is-visible');
    } else {
      $scrollTopBtn.classList.remove('is-visible');
    }
  });
});
//# sourceMappingURL=richter.app-v1.3.js.map
